import React from 'react'
import { Participant } from '@twilio/conversations'

import {
  NxTooltip,
  NxTypography,
  NxUserOnlineStatus,
  OnlineStatus as NxOnlineStatus,
} from '@playvs-inc/nexus-components'
import { Box } from '@plvs/respawn/features/layout'
import { useUserOnlineStatusContext } from '@plvs/respawn/features/userOnlineStatus/UserOnlineStatusProvider'
import { makeStyles } from '@material-ui/core'
import { ParticipantAttributesJSON } from './utils'

const useStyles = makeStyles((theme) => ({
  unread: {
    height: theme.spacing(1),
    width: theme.spacing(1),
    borderRadius: '100%',
    background: theme.palette.OverlayColorBackgroundError,
  },
  tabContainer: {
    alignItems: 'center',
    display: 'flex',
    gridGap: theme.spacing(0.5),
  },
}))

interface Props {
  tabTitle: string
  hasUnreadMessages: boolean
  participants?: Participant[]
}

export const ParticipantsCount: React.FC<Props> = ({
  tabTitle,
  hasUnreadMessages,
  participants,
}) => {
  const { onlineStatusByUserId } = useUserOnlineStatusContext()

  const styles = useStyles()

  if (participants && participants.length) {
    return (
      <NxTooltip
        arrow
        placement="top-start"
        title={
          <Box>
            {participants.map((participant) => {
              const onlineStatus =
                ((onlineStatusByUserId && participant?.identity
                  ? onlineStatusByUserId[participant.identity]
                  : 'placeholder') as NxOnlineStatus) || 'placeholder'

              return (
                <Box key={participant.sid} alignItems="center" display="flex">
                  <NxUserOnlineStatus
                    height={8}
                    onlineStatus={onlineStatus}
                    position="static"
                    removeBorder
                    showTooltip={false}
                    width={8}
                  />

                  <Box pl={1}>
                    <NxTypography key={participant.sid} color="inherit">
                      {
                        (participant?.attributes as ParticipantAttributesJSON)
                          ?.friendlyName
                      }
                    </NxTypography>
                  </Box>
                </Box>
              )
            })}
          </Box>
        }
      >
        <Box className={styles.tabContainer}>
          {hasUnreadMessages && (
            <Box className={styles.unread} data-testid="unread" />
          )}
          <NxTypography color="inherit" variant="button">
            {tabTitle}
          </NxTypography>

          <NxTypography color="inherit" variant="button">
            ({participants.length})
          </NxTypography>
        </Box>
      </NxTooltip>
    )
  }

  return (
    <Box className={styles.tabContainer} data-testid="no-participants">
      {hasUnreadMessages && (
        <Box className={styles.unread} data-testid="unread" />
      )}
      <NxTypography color="inherit" variant="button">
        {tabTitle}
      </NxTypography>
    </Box>
  )
}
